import vsComponent from './vsInputNumber'

export default Vue => {
  Vue.component(vsComponent.name, vsComponent)
}
